import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { jarvisPrimeTransactionActions } from "stores/jarvisPrime/jarvisPrimeTransaction/jarvisPrimeTransactionActions";

const mapStateToProps = (state) => {
  return {
    transactionList: state.jarvisPrime.primeTransaction.transactionList,
    transactionCount: state.jarvisPrime.primeTransaction.transactionCount || 0,
    isLoading: state.jarvisPrime.primeTransaction.loading.transactionList,
    transactionListApiCounter:
      state.jarvisPrime.primeTransaction.transactionListApiCounter,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTransactionListAction:
        jarvisPrimeTransactionActions.getTransactionList,
    },
    dispatch
  );

const jarvisPrimeTransactionStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default jarvisPrimeTransactionStore;
